<template>
  <Modal :option="'filter'" @close="$emit('close')">
    <div class="p-modal__content__header">
      {{ $t('labels.selectFilterCond') }}
    </div>
    <div class="p-modal__content__body">
      <div class="p-filters">
        <FilterItem
          v-for="item in filterItems"
          :key="item.type"
          :list="item.tags"
          :head-text="item.headText"
          :filter-name="item.filterName"
          :filter-type="item.type"
          :value-key="item.valueKey"
          store-name="companiesSearchTagGroups"
          @change-check-box="handleChangeCheckBox"
        />
      </div>
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--right">
        <div class="store-count-wap">
          {{ $t('labels.targetStoreCount') }}
          <span class="store-count">{{ filteredCount }}</span>
          {{ $t('labels.storeCountUnit') }}
        </div>
        <button
          type="button"
          class="c-button__item c-button__item--outline-cancel"
          :disabled="searchAttributesLoading"
          @click="$emit('submit')"
          v-text="$t('labels.checkTargetStores')"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '../Modal'
import FilterItem from '../FilterItem'

export default {
  components: {
    Modal,
    FilterItem
  },
  emits: ['close', 'reset', 'submit', 'change-check-box'],
  computed: {
    ...mapState({
      searchAttributesLoading: state => state.companiesSearchTagGroups.loading,
      companiesSearchTagGroups: state => state.companiesSearchTagGroups.data,
      filteredCount: state => state.companiesLocationStores.filteredCount,
    }),
    disableFilterItemTypes() {
      return ['stores', 'comments', 'ratings', 'competitors', 'competitor_brands', 'emails', 'replies', 'keyword_analysis_targets']
    },
    filterItems() {
      const {
        sites,
        brands,
        franchisees,
        areas,
        user_companies,
        prefectures,
        original_tag_group_a,
        original_tag_group_b,
        original_tag_group_c,
        original_tag_group_d,
        original_tag_group_e,
      } = this.companiesSearchTagGroups
      const arr = [
        this.addAttributes(sites, sites.kind),
        this.addAttributes(brands, brands.kind),
        this.addAttributes(prefectures, prefectures.kind),
        this.addAttributes(areas, areas.kind),
        this.addAttributes(franchisees, franchisees.kind),
        this.addAttributes(user_companies, user_companies.kind),
      ]
      if (original_tag_group_a) arr.push(this.addAttributes(original_tag_group_a, original_tag_group_a.kind))
      if (original_tag_group_b) arr.push(this.addAttributes(original_tag_group_b, original_tag_group_b.kind))
      if (original_tag_group_c) arr.push(this.addAttributes(original_tag_group_c, original_tag_group_c.kind))
      if (original_tag_group_d) arr.push(this.addAttributes(original_tag_group_d, original_tag_group_d.kind))
      if (original_tag_group_e) arr.push(this.addAttributes(original_tag_group_e, original_tag_group_e.kind))
      return arr
    }
  },
  methods: {
    addAttributes(item, type) {
      item.type = type
      item.headText = this.$te('models.filterItem.' + type + '.headText')
        ? this.$t('models.filterItem.' + type + '.headText')
        : this.$t('models.filterItem.all.headText')
      item.filterName = this.$te('models.filterItem.' + type + '.filterName')
        ? this.$t('models.filterItem.' + type + '.filterName')
        : item.label
      return item
    },
    handleChangeCheckBox() {
      this.$emit('change-check-box')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';
.p-modal--filter {
  :deep(.p-modal__content) {
    width: 1076px;
  }
  .store-count-wap {
    margin-right: 10px;
  }
  .store-count {
    margin: 0 5px;
    font-size: 30px;
    font-weight: 700;
    color: $color-accent-primary;
  }
}
</style>
